import resolveCompound from './resolveCompound';
import resolveImageReference from './resolveImageReference';

const resolveImage = ({ rawVal, page }: PropsWithCMSProps<ImageProps>) => {
  const [raw] = Array.isArray(rawVal) ? rawVal : [rawVal];
  const { image: ref, ...props } = resolveCompound<ImageCompound>({ rawVal: raw });
  const image = resolveImageReference({ rawVal: ref, page });
  return image ? ({ ...props, ...image } as ImageType) : undefined;
};

export default resolveImage;
